import { CSSProperties } from 'react'

import { Highlight } from '@/api/services/highlight'

import { PdfPage } from './pdf-page'
import { DUAL_GAP } from './pdf-settings'

type DualPageGroupProps = {
  pair: number[]
  pageWrapperStyle: CSSProperties
  isRtl: boolean
  pageWidth?: number
  pageHeight?: number
  getPageDimensions: (pageIndex: number) => { estimatedWidth?: number; estimatedHeight?: number }
  isPageVisible: (pageIndex: number) => boolean
  highlights: Highlight[]
  searchHighlightRenderer: ((props: { str: string }) => string) | undefined
  onHighlightClick: (highlight: Highlight, e: React.MouseEvent) => void
  onRenderSettled: () => void
  setPageRef: (pageIndex: number) => (el: HTMLDivElement | null) => void
}

export function DualPageGroup({
  pair,
  pageWrapperStyle,
  isRtl,
  pageWidth,
  pageHeight,
  getPageDimensions,
  isPageVisible,
  highlights,
  searchHighlightRenderer,
  onHighlightClick,
  onRenderSettled,
  setPageRef,
}: DualPageGroupProps) {
  const firstPage = pair[0]!
  return (
    <div
      ref={setPageRef(firstPage)}
      data-page-observer={firstPage}
      style={{
        ...pageWrapperStyle,
        display: 'flex',
        // ズームで見開き幅が container を超えても左右スクロールできるよう safe center
        // + flex コンテナ自身を子内容幅まで拡張して scroll コンテナに overflow を伝播
        justifyContent: 'safe center',
        minWidth: 'max-content',
        gap: `${DUAL_GAP}px`,
        flexDirection: isRtl ? 'row-reverse' : 'row',
      }}
    >
      {pair.map((pageIdx) => {
        const dualW = pageWidth ? pageWidth / (pair.length > 1 ? 2 : 1) : undefined
        const dims = getPageDimensions(pageIdx)
        // 高さ基準（横スクロール）では見開きでも高さは揃えたままにし、幅だけ横に並べる
        const isHeightBased = pageHeight !== undefined
        const dualEstW = dims.estimatedWidth
          ? dims.estimatedWidth / (!isHeightBased && pair.length > 1 ? 2 : 1)
          : undefined
        const dualEstH = dims.estimatedHeight
          ? dims.estimatedHeight / (!isHeightBased && pair.length > 1 ? 2 : 1)
          : undefined
        return (
          <PdfPage
            key={pageIdx}
            pageIndex={pageIdx}
            width={dualW}
            height={pageHeight}
            isVisible={isPageVisible(pageIdx)}
            highlights={highlights}
            estimatedWidth={dualEstW}
            estimatedHeight={dualEstH}
            searchHighlightRenderer={searchHighlightRenderer}
            onHighlightClick={onHighlightClick}
            onRenderSettled={onRenderSettled}
          />
        )
      })}
    </div>
  )
}
